export enum TicketDrawerBusyReason {
  APPROVING_LOAD = 'approving-load',
  APPROVING_LOAD_AND_NEXT = 'approving-load-and-next',
  CHANGING_TICKET_FLAGGED_STATE = 'changing-ticket-flagged-state',
  CHANGING_TICKET_POTENTIAL_DUPLICATE_STATE = 'changing-ticket-potential-duplicate-state',
  DELETING_LOAD = 'deleting-load',
  DELETING_TICKET = 'deleting-ticket',
  DISMISSING_AI_REVIEW = 'dismissing-ai-review',
  MANIPULATING_IMAGE = 'manipulating-image',
  SAVING_TICKET = 'saving-ticket',
  UNAPPROVING_LOAD = 'unapproving-load',
  UNDOING_AI_REVIEW_DISMISSAL = 'undoing-ai-review-dismissal',
}
